import { useState, useMemo, useEffect, useCallback } from 'react';

interface FetchProps {
  service: any;
  func: any;
  payload: any;
  skip?: any;
  dependency: any[];
  onError?: (error: any) => void;
  onSuccess?: (response: any) => void;
}

const useFetch = ({ service, func, payload, skip, dependency, onError, onSuccess }: FetchProps) => {
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);

  const getData = useCallback(() => {
    setLoading(true);
    service[func](payload)
      .then((response: any) => {
        setLoading(false);
        // Handle both paginated response (with records) and direct array responses (for lookups)
        if (Array.isArray(response)) {
          setData(response);
          setTotal(response.length);
        } else {
          setData(response?.data?.data ?? []);
          setTotal(response?.data?.pagination?.total ?? 0);
        }
        onSuccess && onSuccess(response?.data ?? {});
      })
      .catch((error: any) => {
        setLoading(false);
        setData([]);
        setTotal(0);
        onError && onError(error);
      });
  }, [service, func, payload]);

  useEffect(() => {
    if (!skip) {
      getData();
    }
  }, dependency);

  return useMemo(() => {
    return {
      total,
      loading,
      data,
    };
  }, [total, loading, data]);
};

export default useFetch;
